export default {
  "content": "<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M2 5h12v2H8c0 2.21-1.79 4-4 4v2c2.21 0 4 1.79 4 4h8c0-2.21 1.79-4 4-4h2v6H2V5zm4 2H4v2c1.1 0 2-.9 2-2zM4 17v-2c1.1 0 2 .9 2 2H4zm16-2c-1.1 0-2 .9-2 2h2v-2z\" fill=\"#ff00cb\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M9 12c0-1.66 1.34-3 3-3s3 1.34 3 3-1.34 3-3 3-3-1.34-3-3zm4 0c0-.55-.45-1-1-1s-1 .45-1 1 .45 1 1 1 1-.45 1-1z\" fill=\"#ff00cb\"/><path d=\"M21 5h-5v2h2.586l-2.793 2.793 1.414 1.414L20 8.414V11h2V6a1 1 0 00-1-1z\" fill=\"#ff00cb\"/>",
  "attrs": {
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};